import { render, staticRenderFns } from "./DatosEntrada.vue?vue&type=template&id=0a4efeea"
import script from "./DatosEntrada.vue?vue&type=script&lang=js"
export * from "./DatosEntrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports